module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADESURBVHgBrZKBDYIwFER/jQMwQkdghI6AG7CBI+gGsoFsoBvgBo7QblA3qPfNx3yJVStccpSG6+NaMASllCoMNZUrGGMCA9o0T87gMkiLDZXrBJ+5ySDEI2x/WYlcrdeNkKjq7T4sruCD5KL4CWFbuJeA57OaALbqZZ0A/QtEhRt5yLrKfKzOo1PZ9xAVaBUsTptpyDq3f3x/3toFtw3cY37LZbMQAQUMHX3RihYQN+GaDtX3VK7qcZUfx6f/xAduaQndAVPTZZysQgu4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/icon-email.png
// module id = bUnp
// module chunks = 0